<div #notificationElement class="border-bottom-1 surface-border" [id]="indexTag">
  <div class="container" [@readState]="readState ? 'read' : 'unread'">
    <div class="icon" (click)="changeReadStatus()">
      <i class="{{notificationIcon}}"></i>
      <!--      hover-class="fa-solid fa-location-arrow" -->
    </div>
    <div class="content">
      <p class="title clamp-one-row" (click)="changeReadStatus()"><b>{{notification.precomputedMessage}}</b></p>
      <div style="margin-bottom: 16px">
        <div (click)="changeReadStatus()" style="display: inline-block; width: 250px">
          <span>On <b>{{formattedTime}}</b></span>
        </div>
        <div style="display: inline-block">
          <span class="navigate-button" (click)="redirectToEntity()">
                   See more <i class="fa-solid fa-arrow-right"></i>
                </span>
        </div>
      </div>
    </div>
    <div class="dismiss">
      <div class="dismiss-button">
        <i class="fa-duotone fa-circle-xmark" (click)="dismissNotification()"></i>
      </div>
    </div>
  </div>
</div>

